import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';

export const CardDialog = styled(Dialog)`
  & .MuiDialog-paper {
    max-width: none !important;
    min-width: 25%;
  }
`;
